import { Box, BoxProps, Tooltip } from "../../components";
import InfoIcon from "@mui/icons-material/Info";

type InfoTooltipProps = Omit<BoxProps, "children"> & {
  handleClick?: () => any;
  value:
    | string
    | number
    | boolean
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | React.ReactFragment
    | React.ReactPortal; // copied from Tooltip's title
};

export const InfoTooltip = ({ handleClick, value, ...rest }: InfoTooltipProps) => {
  return (
    <Box display="flex" {...rest}>
      <Tooltip onClick={() => handleClick ?? null} title={value}>
        <InfoIcon opacity="0.6" color="info" fontSize="small" />
      </Tooltip>
    </Box>
  );
};
